module.exports = __webpack_public_path__ + "static/media/podium-star.567ab876.svg";